import React from "react";

export interface SectionProps {
    className?: string;
    title: string;
    id?: string;
}

const Section: React.FC<SectionProps> = ({ title, id, className, children }) => {
    id = id || title.replace(/\s+/g, "_").replace(/#/g, "-").toLowerCase();

    return (
        <section className="section">
            <h1 className="section__title" id={id}>{title}</h1>
            <div className={`section__inner ${className || ""}`.trim()}>
                {children}
            </div>
        </section>
    );
};

export default Section;

